import { render, staticRenderFns } from "./DosyaLayer.vue?vue&type=template&id=1f37a480&"
import script from "./DosyaLayer.vue?vue&type=script&lang=js&"
export * from "./DosyaLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports